import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./../../../../hooks";

import { Button, Flex, Modal, Typography } from "djuno-design";
import {
  getK8ServiceAsync,

  handleToggleK8UpgradeVersionModal,

  K8UpgradeVersionAsync,

  selectK8Service,
  selectK8ServiceActionLoading,
  selectK8ServiceLoading,
  selectK8UpgradeVersionModal,
} from "./../../../../store/kubernetes/k8ServiceSlice";


const K8UpgradeVersionModal = () => {
  const isOpen = useAppSelector(selectK8UpgradeVersionModal);

  const k8Service = useAppSelector(selectK8Service);
  const k8ServiceLoading = useAppSelector(selectK8ServiceLoading);
  const k8ServiceActionLoading = useAppSelector(selectK8ServiceActionLoading);
  const dispatch = useAppDispatch();

useEffect(() => {
  if (k8Service) {
    dispatch(getK8ServiceAsync({ id: k8Service.id }));
  }
}, [dispatch]);


  const onSubmit = () => {
    if (k8Service && !k8ServiceLoading) {
   dispatch(
           K8UpgradeVersionAsync({
             id: k8Service.id,
             data: { strategy: "NEXT_MINOR" },
           })
         ).then((action) => {
        if (action.type === "k8-service/update/fulfilled") {
          handleOnClose();
          dispatch(getK8ServiceAsync({ id: k8Service.id }));
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleToggleK8UpgradeVersionModal(false));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      title="Usage to the next minor version of Kubernetes"
    >
      <div className="flex flex-col w-full mt-5">
    

        <div className="space-y-5 mt-4">
          <Typography.Text className="!text-sm">
          With this feature, you can upgrade your cluster from one version to the next (1.31 to 1.32). Before you launch this action, please back up your cluster’s configuration, and check that your worker tools are compatible with this new version.
          </Typography.Text>
        </div>
        <div className="space-y-5 mt-4">
          <Typography.Text className="!text-sm">
          Please also ensure that your cluster includes enough worker nodes to allow for a rolling upgrade. Once the update has been performed, you cannot revert to the previous version.
          </Typography.Text>
        </div>
        <div className="space-y-5 mt-4">
          <Typography.Text className="!text-sm">
          To minimise downtime for your pods and your overall service, we will drain each of your nodes, only moving on to the next node when the current one is functional (i.e. when the status changes to ‘Ready’). Your admin components and server API will also be updated.
          </Typography.Text>
        </div>
        <div className="space-y-5 mt-4">
          <Typography.Text className="!text-sm">
        This operation usually takes around 10 minutes, depending on your cluster type and size.
          </Typography.Text>
        </div>
        <div className="space-y-5 mt-4">
          <Typography.Text className="!text-sm">
        Upgrade to version: { k8Service?.version
  ? `${k8Service.version.split(".")[0]}.${+k8Service.version.split(".")[1] + 1}`
  : "" }

          </Typography.Text>
        </div>

        <Flex items="center" justify="end" className="gap-2 mt-5">
          <Button onClick={handleOnClose}>Cancel</Button>
          <Button
            uiType="primary"
            type="submit"
            onClick={onSubmit}
            loading={k8ServiceActionLoading}
          >
            Confirm
          </Button>
        </Flex>
      </div>
    </Modal>
  );
};

export default K8UpgradeVersionModal;
